Vue.config.devtools = true;
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import vSelect from 'vue-select'
import Vuelidate from "vuelidate";
import axios from "axios";
import VueAxios from "vue-axios";
// import './registerServiceWorker'
// import VueGoodTablePlugin from "vue-good-table";
// import the styles
// import "vue-good-table/dist/vue-good-table.css";

// Vue.use(VueGoodTablePlugin);
// Vue.use(window.vueGoodTable.default);

Vue.config.productionTip = false
Vue.component('v-select', vSelect)
Vue.use(Vuelidate);
Vue.use(VueAxios, axios);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js